import { render } from "./PassRedeem.vue?vue&type=template&id=5a9c3521&scoped=true"
import script from "./PassRedeem.vue?vue&type=script&lang=js"
export * from "./PassRedeem.vue?vue&type=script&lang=js"

import "./PassRedeem.vue?vue&type=style&index=0&id=5a9c3521&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9c3521"]])

export default __exports__